import { LineItem } from '@commerce/types/cart'

const isPartnerDeliveryLineItem = (lineItem: LineItem) => {
  return !!(lineItem.variant?.barcode && lineItem.variant?.barcode?.length === 13)
}

export default isPartnerDeliveryLineItem
